import Colors from 'Theme/Colors'
import React from 'react'
import Styles from './OverviewInfoCard.module.css'
import { IFSkeleton } from 'Components'

const OverviewInfoCardSkeleton = ({}) => {
  return (
    <div
      style={{
        backgroundColor: Colors.white,
      }}
      className={Styles.Card}
    >
      <div className={Styles.Section}>
        <div className={Styles.Top}>
          <IFSkeleton variant="circular" height="1rem" width="1rem" />
          <IFSkeleton
            variant="text"
            className={Styles.Title}
            height="1rem"
            width="6.5rem"
          />
        </div>
        <div>
          <IFSkeleton
            variant="text"
            className={Styles.ValueSkeleton}
            height="1rem"
            width="5rem"
          />
          <div className={Styles.Top}>
            <div className={Styles.ArrowContainer}>
              <IFSkeleton
                variant="circular"
                className={Styles.Arrow}
                height="1rem"
                width="1rem"
              />
            </div>
            <IFSkeleton
              variant="text"
              className={Styles.Percentage}
              height="1rem"
              width="5rem"
            />
          </div>
        </div>
      </div>
      <div className={Styles.Section}>
        <div className={Styles.Top}>
          <IFSkeleton variant="circular" height="1rem" width="1rem" />
          <IFSkeleton
            variant="text"
            className={Styles.Title}
            height="1rem"
            width="6.5rem"
          />
        </div>
        <div>
          <IFSkeleton
            variant="text"
            className={Styles.ValueSkeleton}
            height="1rem"
            width="5rem"
          />
          <div className={Styles.Top}>
            <div className={Styles.ArrowContainer}>
              <IFSkeleton
                variant="circular"
                className={Styles.Arrow}
                height="1rem"
                width="1rem"
              />
            </div>
            <IFSkeleton
              variant="text"
              className={Styles.Percentage}
              height="1rem"
              width="5rem"
            />
          </div>
        </div>
      </div>
      <div className={Styles.Section}>
        <div className={Styles.Top}>
          <IFSkeleton variant="circular" height="1rem" width="1rem" />
          <IFSkeleton
            variant="text"
            className={Styles.Title}
            height="1rem"
            width="6.5rem"
          />
        </div>
        <div>
          <IFSkeleton
            variant="text"
            className={Styles.ValueSkeleton}
            height="1rem"
            width="5rem"
          />
          <div className={Styles.Top}>
            <div className={Styles.ArrowContainer}>
              <IFSkeleton
                variant="circular"
                className={Styles.Arrow}
                height="1rem"
                width="1rem"
              />
            </div>
            <IFSkeleton
              variant="text"
              className={Styles.Percentage}
              height="1rem"
              width="5rem"
            />
          </div>
        </div>
      </div>
      <div className={Styles.Section}>
        <div className={Styles.Top}>
          <IFSkeleton variant="circular" height="1rem" width="1rem" />
          <IFSkeleton
            variant="text"
            className={Styles.Title}
            height="1rem"
            width="6.5rem"
          />
        </div>
        <div>
          <IFSkeleton
            variant="text"
            className={Styles.ValueSkeleton}
            height="1rem"
            width="5rem"
          />
          <div className={Styles.Top}>
            <div className={Styles.ArrowContainer}>
              <IFSkeleton
                variant="circular"
                className={Styles.Arrow}
                height="1rem"
                width="1rem"
              />
            </div>
            <IFSkeleton
              variant="text"
              className={Styles.Percentage}
              height="1rem"
              width="5rem"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OverviewInfoCardSkeleton
